import { defineAsyncComponent } from 'vue'
export default {
  account: defineAsyncComponent(() => import("/opt/render/project/src/apps/frontend/layouts/account.vue").then(m => m.default || m)),
  compact: defineAsyncComponent(() => import("/opt/render/project/src/apps/frontend/layouts/compact.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/opt/render/project/src/apps/frontend/layouts/default.vue").then(m => m.default || m)),
  "side-image": defineAsyncComponent(() => import("/opt/render/project/src/apps/frontend/layouts/side-image.vue").then(m => m.default || m))
}